import { t as p } from "./index-c4176047.js";
import { g as y } from "./index-c4176047.js";
import { jsx as o } from "react/jsx-runtime";
import { _ as s, a as h } from "./createTheme-feb5b756.js";
import "react";
import { T as m, P as r } from "./identifier-6f4bda5a.js";
import { ThemeProvider as c, StyledEngineProvider as u } from "@mui/system";
const f = ["theme"];
function n(e) {
  let {
    theme: t
  } = e, d = s(e, f);
  const i = t[m];
  return /* @__PURE__ */ o(c, h({}, d, {
    themeId: i ? m : void 0,
    theme: i || t
  }));
}
process.env.NODE_ENV !== "production" && (n.propTypes = {
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: r.oneOfType([r.object, r.func]).isRequired
});
function E(e) {
  return /* @__PURE__ */ o(u, { injectFirst: !0, children: /* @__PURE__ */ o(n, { theme: p, children: e.children }) });
}
export {
  E as ThemeProvider,
  y as getColor,
  p as theme
};
//# sourceMappingURL=theme.entry.js.map
